import DeleteAccountContainer from './DeleteAccountContainer';

export default DeleteAccountContainer;
